// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_3ggqOajtIyhBGE5hsAJtVi","text":"A0nCNhPxrm_eLw73E4NGQ"};